import { hooks } from "hsl-core/FundExplorer";

export default function useSoftGrouping() {
	const { capability, region, ...others } = hooks.useExplorerStore(
		(store) => store.activeFilters,
	);
	const hasNoCapability = !capability || capability.length === 0;
	const hasRegion = region && region.length > 0;
	const hasOthers =
		others && Object.values(others).some((value) => value.length > 0);

	// if no capability is selected or any other filter is selected do not group
	if (hasNoCapability || hasOthers) {
		return 0;
	}
	if (hasRegion) {
		// if more than one regions are selected do not group
		// otherwise group and label by primary + secondary prop values
		return region.length === 1 ? 2 : 0;
	}
	// capability is selected
	// group by primary prop
	return 1;
}
